import { MessageContextAction } from './message-composer-reducer';

import { OrganizationFileResult } from '../../../api/file-upload-api-client';

import { LanguageState } from './message-composer-state';

import { LanguageCode } from '../../../util/languages';
import { MessageType } from '../../../util/message-types';

type MessageComposerActionOptions = {
  forceUpdate: boolean;
};

export const resetLanguageStateAction = (
  state: Record<LanguageCode, LanguageState>,
  { forceUpdate }: MessageComposerActionOptions,
): MessageContextAction => ({
  type: 'RESET_LANGUAGE_STATE',
  state,
  forceUpdate,
});

export const updateMessageForLanguageAction = (
  params: {
    languageCode: LanguageCode;
    message: string;
  },
  options: MessageComposerActionOptions = { forceUpdate: false },
): MessageContextAction => ({
  type: 'UPDATE_MESSAGE_FOR_LANGUAGE',
  ...params,
  ...options,
});

export const replaceLanguageToMessageAction = (
  languageToMessage: Record<LanguageCode, string>,
  options: MessageComposerActionOptions = { forceUpdate: true },
): MessageContextAction => ({
  type: 'REPLACE_LANGUAGE_TO_MESSAGE',
  languageToMessage,
  ...options,
});

export const uploadFileForLanguageAction = (params: {
  languageCode: LanguageCode;
  fileName: string;
  resultLink: OrganizationFileResult;
}): MessageContextAction => ({
  type: 'UPLOAD_FILE_FOR_LANGUAGE',
  ...params,
});

export const removeFileForLanguageAction = (params: {
  languageCode: LanguageCode;
  urlFileMapping: UrlFileMapping;
}): MessageContextAction => ({
  type: 'REMOVE_FILE_FOR_LANGUAGE',
  ...params,
});

export const updateMessageErrorAction = (params: {
  messageError: string | null;
  languageCode: LanguageCode;
}): MessageContextAction => ({
  type: 'UPDATE_MESSAGE_ERROR_FOR_LANGUAGE',
  ...params,
});

export const updateSubjectErrorAction = (params: {
  subjectError: string | null;
  languageCode: LanguageCode;
}): MessageContextAction => ({
  type: 'UPDATE_SUBJECT_ERROR_FOR_LANGUAGE',
  ...params,
});

export const updateMessageTypeAction = (
  messageType: MessageType,
  options: MessageComposerActionOptions = { forceUpdate: false },
): MessageContextAction => ({
  type: 'UPDATE_MESSAGE_TYPE',
  messageType,
  ...options,
});

export const updateIsTranslatingAction = (params: {
  languageCode: LanguageCode;
  isTranslating: boolean;
}): MessageContextAction => ({ type: 'UPDATE_IS_TRANSLATING', ...params });

export const updateStreamingHackTextAction = (params: {
  languageCode: LanguageCode;
  streamingHackText: string;
}): MessageContextAction => ({ type: 'UPDATE_STREAMING_HACK_TEXT', ...params });

export const setStreamingHackDoneAction = (params: {
  languageCode: LanguageCode;
}): MessageContextAction => ({ type: 'STREAMING_HACK_DONE', ...params });
